export default class User {
	constructor() {
		this.id = '';
		this.name = '';
		this.email = '';
		this.password = '';
		this.roles = [];
		this.auth = '';
	}
}
